import { schema } from 'normalizr';

const entitySchema = new schema.Entity('document', undefined, { idAttribute: 'id' });

export default entitySchema;